var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"bars"},[_c('div',{staticClass:"progress",style:({ transform: 'translateX(' + _vm.x + '%)' })})])])}
var staticRenderFns = []

export { render, staticRenderFns }